import config from './config'
import './freight-forward/Status'
import './freight-forward/ContainerSize'

config.onAny().passThrough()
